
import React, { memo } from 'react';

import { Button, Text } from '../../../../../ui-kit';
import '../styles/_form-block-description.scss';














function getDescription(description) {
  if (!description) {return <p />;}

  if (typeof description === 'string') {return <Text>{description}</Text>;}

  return description.map(
    (descString) => descString ? <Text key={descString}>{descString}</Text> : null
  );
}

function FormBlockDescription(
{
  name,
  description,
  buttonText,
  buttonBusy,
  buttonDisabled,
  isPrimaryButton,
  onClickButton,
  hideButton,
  highlightedName,
  additionalContent
})
{
  return [
  <div key="form-block-desc" className="form-block-description">
      <Text highlighted={highlightedName}>{name}</Text>
      {getDescription(description)}
    </div>,
  !hideButton ?

  <Button
    key="form-block-btn"
    busy={buttonBusy}
    onClick={onClickButton}
    disabled={buttonDisabled}
    type={isPrimaryButton ? void 0 : 'TERTIARY'}>

          {buttonText}
        </Button> :

  null,
  additionalContent];

}

FormBlockDescription.defaultProps = {
  additionalContent: null
};

export default memo(FormBlockDescription);